import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { PlatformService } from '@core/services/platform/platform.service';
import { ThemeService } from '@core/services/theme/theme.service';
import { AppVersionGateService } from '@core/services/app-version-gate/app-version-gate.service';
import { APP_LINKS } from '@shared/constants/app-links.constants';

@Component({
  selector: 'mohlel-update-required-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, DialogModule],
  templateUrl: './update-required-dialog.component.html',
  styleUrl: './update-required-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateRequiredDialogComponent {
  private gateService = inject(AppVersionGateService);
  private platformService = inject(PlatformService);

  readonly isBlocked = computed(() => this.gateService.isBlocked());

  readonly storeUrl = computed(() => {
    return this.platformService.isIOS() ? APP_LINKS.appStore : APP_LINKS.googlePlay;
  });
}
